module.exports = __webpack_public_path__ + "static/img/icon-onboard.9b860386.svg";